import { DigitalGpSubmission, TrackingCodes } from '@sky-distribution/digital-gp-submission';
import { withoutIncompleteDiscount } from '@sky-distribution/gp-onboarding-shared-utils';
import { getDigitalSubmissionWithProducerData } from './producerData';
import { getProducerDataTrackingCodes, getSubmissionWithTrackingCodes } from './trackingCodes';

export const getDigitalSubmissionWithMetaData = (
  submission: DigitalGpSubmission,
  trackingCodes: TrackingCodes,
) => {
  const submissionWithTrackingCodes = getSubmissionWithTrackingCodes(
    withoutIncompleteDiscount(submission),
    trackingCodes,
  );
  const producerDataTrackingCodes = getProducerDataTrackingCodes(trackingCodes);

  return getDigitalSubmissionWithProducerData(
    submissionWithTrackingCodes,
    producerDataTrackingCodes,
  );
};
